import { useDispatch } from "react-redux";
import { signout } from "../store";
import showToast from "../utils/toastNotifications";
import { useEffect } from "react";

const useSessionMonitor = () => {
  
  const dispatch = useDispatch();

  useEffect(() => {
    const handleStorageChange = (e) => {
      // Check if token is removed
      if (e.key === "token" && !e.newValue) {
        dispatch(signout());
        showToast("error", "Session Expired. Please login Again");
        setTimeout(() => {
          window.location.href = "/signin";
        }
        , 2000);
      }
    };

    // Check if token is expired
    const checkTokenExpiration = () => {
      const token = localStorage.getItem("token");

      // If no token exists, return early
      if (!token) return;

      try {
        // Split the token and get the payload part
        const [, payloadBase64] = token.split(".");

        // Decode the base64 payload
        const decodedPayload = atob(payloadBase64);

        // Parse the JSON payload
        const tokenData = JSON.parse(decodedPayload);

        // Check expiration
        const expirationTime = tokenData.exp * 1000; // Convert to milliseconds

        if (Date.now() >= expirationTime) {
          localStorage.removeItem("token");
          dispatch(signout());
          showToast("error", "Session Expired. Please login Again");
          setTimeout(() => {
            window.location.href = "/signin";
          }
          , 2000);
        }
      } catch (error) {
        console.error("Error checking token expiration:", error);
        // Optional: Handle invalid token by logging out
        localStorage.removeItem("token");
        dispatch(signout());
        showToast("error", "Session Expired. Please login Again");
        setTimeout(() => {
          window.location.href = "/signin";
        }
        , 2000);
      }
    };

    // Initial check
    checkTokenExpiration();

    // Set up periodic checks
    const intervalId = setInterval(checkTokenExpiration, 60000); // Check every minute

    // Set up storage event listener
    window.addEventListener("storage", handleStorageChange);

    // Cleanup
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(intervalId);
    };
  }, [dispatch]);
};

export default useSessionMonitor;
